import { createSlice } from "@reduxjs/toolkit";
import { searchApi, searchApiDebounced } from "../thunks/searchApiThunk";

const searchSlice = createSlice({
  name: "search",
  initialState: {
    query: "",
    results: [],
    loading: false,
    error: null,
  },
  reducers: {
    setQuery: (state, action) => {
      state.query = action.payload;
    },
    clearResults(state) {
      state.results = []; // Clear the results array
      state.error = null;  // Optionally clear any errors
      state.loading = false; // Stop loading state
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle regular search
      .addCase(searchApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchApi.fulfilled, (state, action) => {
        state.loading = false;
        state.results = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(searchApi.rejected, (state, action) => {
        state.loading = false;
        // Don't show error for cancelled requests
        if (action.payload?.message !== 'Search cancelled') {
          state.error = action.error?.message || 'Search failed';
        }
      })
      // Handle debounced search
      .addCase(searchApiDebounced.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(searchApiDebounced.fulfilled, (state, action) => {
        state.loading = false;
        // Handle the nested result from debounced search
        if (action.payload?.payload) {
          state.results = Array.isArray(action.payload.payload) ? action.payload.payload : [];
        } else {
          state.results = [];
        }
      })
      .addCase(searchApiDebounced.rejected, (state, action) => {
        state.loading = false;
        // Don't show error for cancelled requests
        if (action.payload?.message !== 'Search cancelled') {
          state.error = action.error?.message || 'Search failed';
        }
      });
  },
});

export const { setQuery, clearResults } = searchSlice.actions;
export default searchSlice.reducer;
